import { X } from 'lucide-react';

// Lo que la cola intentó reenviar y el servidor no aceptó.
//
// UNA RECEPCIÓN RECHAZADA NO ES LO MISMO QUE UN MOVIMIENTO RECHAZADO, y
// esta es toda la razón de que este aviso exista aparte:
//
//   · Un movimiento rechazado es TRABAJO QUE NO SE HIZO. La existencia no
//     se movió, el operador vuelve a intentarlo y ya está.
//   · Una recepción rechazada es MERCANCÍA QUE YA ESTÁ EN EL ALMACÉN y que
//     no va a figurar en el inventario si nadie se entera. No hay nada que
//     reintentar: hay que ir a registrarla de otra forma.
//
// Meterlas en la misma frase —«N cosas fueron rechazadas»— haría que la
// segunda se leyera como la primera, que es la manera de que a nadie le
// parezca urgente. Por eso van separadas, con palabras distintas, y el
// aviso entero se pone rojo en cuanto hay una recepción dentro.
export default function AvisoRechazados({ rechazados, onDescartar }) {
  if (!rechazados?.length) return null;

  const recepciones = rechazados.filter((r) => r._tipo === 'RECEPCION').length;
  const movimientos = rechazados.length - recepciones;

  return (
    <div role="alert" className={`text-xs px-4 py-2 flex items-start gap-2 ${
      recepciones ? 'bg-red-100 text-red-900' : 'bg-amber-100 text-amber-900'}`}>
      <span className="flex-1">
        {recepciones > 0 && (
          <span className="block font-semibold">
            {recepciones} recepción(es) guardada(s) sin señal fueron rechazadas
            al reenviar. Esa mercancía está en el almacén y NO figura en el
            inventario: recíbela de nuevo, o regístrala como entrada si la
            orden ya se cerró.
          </span>
        )}
        {movimientos > 0 && (
          <span className="block">
            {movimientos} movimiento(s) en cola fueron rechazados al reenviar
            (p. ej. stock insuficiente). Regístralos de nuevo.
          </span>
        )}
      </span>
      <button type="button" onClick={onDescartar}
              aria-label="Descartar el aviso de trabajo rechazado">
        <X className="h-4 w-4" aria-hidden="true" />
      </button>
    </div>
  );
}
